import {
  jb_language_list_css_default
} from "./chunk.BDCYLWNX.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-language-list/jb-language-list.ts
var JbLanguageList = class extends r {
  render() {
    return ke`
      ${this.languageLabel ? ke`<label part="label">${this.languageLabel}</label>` : D}
      <ul>
        ${this.languages.map(
      (language) => ke`<li>
              <jb-anchor
                .text=${language.text}
                .link=${language.link}
                .ariaLabels=${language.ariaLabels}
                exportparts="anchor"
                >${language.text}</jb-anchor
              >
            </li>`
    )}
      </ul>
    `;
  }
};
JbLanguageList.styles = jb_language_list_css_default;
__decorateClass([
  n()
], JbLanguageList.prototype, "languageLabel", 2);
__decorateClass([
  n({ type: Array })
], JbLanguageList.prototype, "languages", 2);
JbLanguageList = __decorateClass([
  customElement("jb-language-list")
], JbLanguageList);

export {
  JbLanguageList
};
